/**
 * Returns a consistent avatar URL for a user.
 * If the user has an avatar_url, returns it.
 * Otherwise, generates a letter-based placeholder using ui-avatars.com.
 */
export const getAvatarUrl = (avatarUrl, name = '?', size = 128) => {
  if (avatarUrl && avatarUrl !== '/default-avatar.png') return avatarUrl;
  const encoded = encodeURIComponent(name || '?');
  return `https://ui-avatars.com/api/?name=${encoded}&size=${size}&background=4A90E2&color=fff&bold=true`;
};
